enum LinkGroupOrientation {
    ROW = 'Row',
    STACKED = 'Stacked',
}

export default LinkGroupOrientation
